import { BrandConfig, BrandConfigKey, BrandConfigValue } from './components/brand-settings-screen/brand-settings.view-model';
import { createAction, props } from '@ngrx/store';

const feature = '[Brand settings]';

export const fetchBrandConfigKeys = createAction(`${feature} fetch brand config keys`);
export const fetchBrandConfigKeysSuccess = createAction(
  `${feature} fetch brand config keys success`,
  props<{ brandConfigKeys: BrandConfigKey[] }>()
);
export const fetchBrandConfigKeysFail = createAction(`${feature} fetch brand config keys fail`, props<{ errorMessage: string }>());

export const fetchBrandConfigValues = createAction(`${feature} fetch brand config values`);
export const fetchBrandConfigValuesSuccess = createAction(
  `${feature} fetch brand config values success`,
  props<{ brandConfigValues: BrandConfigValue[] }>()
);
export const fetchBrandConfigValuesFail = createAction(`${feature} fetch brand config values fail`, props<{ errorMessage: string }>());

export const updateBrandConfig = createAction(`${feature} update brand config`, props<{ brandConfig: BrandConfig[] }>());
export const updateBrandConfigSuccess = createAction(`${feature} update brand config success`);
export const updateBrandConfigFail = createAction(`${feature} update brand config fail`, props<{ errorMessage: string }>());
